module.exports = __webpack_public_path__ + "blog1.jpg?74c4374b5b43d41c2a42f7e1f96fa41f";